import * as React from 'react'
import styled from 'styled-components'
import { CartItem } from 'hooks/account/types'
import theme from 'theme'
import useTranslations from 'hooks/useTranslations'

type Props = {
  item: CartItem
}

export default function CustomTailor(props: Props) {
  if (!props.item.customTailor) return <div />
  const size = props.item.customTailor?.size
  const t = useTranslations<'molecules-account-CartItem'>()
  const lengthVal = size.length || size.width

  return (
    <Wrapper className="CustomTailor" data-cy-state="has-custom-tailor">
      <div>
        {t('customtailor_form', {
          FORM: '-',
          __transformers: {
            FORM: (_, vars) => <b> {vars.FORM_label} </b>
          },
          VALUE: t(`customtailor_shape_${props.item.customTailor.form}`)
        })}
      </div>
      <div className="size-wrapper">
        <div>
          {t('customtailor_width', {
            WIDTH: '-',
            __transformers: {
              WIDTH: (_, vars) => <b> {vars.WIDTH_label} </b>
            },
            VALUE: size.width
          })}
        </div>
        <div>
          {t('customtailor_length', {
            LENGTH: '-',
            __transformers: {
              LENGTH: (_, vars) => <b> {vars.LENGTH_label} </b>
            },
            VALUE: lengthVal
          })}
        </div>
      </div>
      <div>
        {t('customtailor_brink', {
          BRINK: '-',
          __transformers: {
            BRINK: (_, vars) => (
              <span>
                <b> {vars['BRINK_label']}: </b>{' '}
                {vars[`BRINK_${props.item.customTailor?.brink.type}`]}
              </span>
            )
          },
          WIDTH: props.item.customTailor?.brink.width || ''
        })}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing('xxs')};
  ${theme.ty('r-xs', null, 'r-s')}
  color: ${theme.colors.shade.b2};

  > .size-wrapper {
    height: 50%;
    display: flex;
    flex-direction: column;

    gap: ${theme.spacing('xxs')};
    @media (min-width: ${theme.ms.MD}px) {
      height: auto;
      flex-direction: row;
    }
  }
`
